import { useState, useContext } from "react";
import { IsEnable, CarType, UserType } from "../enums";
import { PAYMENT_EDIT_FORM } from "../data/forms";
import dayjs from "dayjs";
import { URLS } from "./index";
import { Modal, Form } from "../components";
import {
  Button,
  Tag,
  message,
  Popconfirm,
  Form as AntForm,
  Tooltip,
  Input,
  Select,
} from "antd";
import { GlobalContext } from "../context";
import noimage from "../assets/icons/noimage.png";

const Index = ({ value, record, format, formData, url, method }) => {
  const context = useContext(GlobalContext);
  const [isOpen, setIsOpen] = useState({
    carOpen: false,
    infoOpen: false,
  });
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editForm] = AntForm.useForm();
  const [reason, setReason] = useState("");
  const [status, setStatus] = useState(1);

  const onClose = (attr) => {
    setIsOpen((e) => {
      return { ...e, [attr]: false };
    });
  };
  const openModal = (attr) => {
    setIsOpen((e) => {
      return { ...e, [attr]: true };
    });
  };

  const saveCars = (values, record) => {
    setLoading(true);
    context
      ?.request({
        url: "/admin/concar",
        method: "PUT",
        ismessage: true,
        body: {
          ...values,
          userid: record?.id,
        },
      })
      .then((res) => {
        setLoading(false);
        if (res?.success) {
          onClose("carOpen");
        }
      });
  };

  const saveEdit = (values, record) => {
    setLoading(true);
    context
      ?.request({
        url: "/license/editpay",
        method: "POST",
        ismessage: true,
        body: {
          ...values,
          day: values?.day ? Number(values.day) : 0,
        },
      })
      .then((res) => {
        setLoading(false);
        setIsOpenEdit(false);
        editForm?.resetFields();
      });
  };

  const handleEdit = (e) => {
    if (e?.isactive !== 1) setIsOpenEdit(true);
    else message.error("Амжилттай гүйлгээг засах боломжгүй");
  };

  const handleDelete = () => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth?.user?.type === UserType.Супер_админ) {
      if (url) {
        context?.request({
          url: `${url}/${record?.id}`,
          method: method || "GET",
          ismessage: true,
          model: "reload",
        });
      } else {
        let id = record?.id;
        let url = "/notification/admin";
        context?.request({
          url: `${url}/${id}`,
          method: "DELETE",
          ismessage: true,
          model: "reload",
        });
      }
    } else {
      message.error("Хэрэглэгчийн эрхгүй байна.");
    }
  };
  const handleVerify = () => {
    if (status === 1) {
      context?.request({
        url: `/order/admin/approve/${record?.id}`,
        method: "POST",
        ismessage: true,
        model: "reload",
      });
    } else if (status === 2) {
      if (reason) {
        context?.request({
          url: `/order/admin/cancel`,
          method: "POST",
          ismessage: true,
          model: "reload",
          body: {
            orderid: record?.id,
            smstext: reason,
          },
        });
      } else message.error("Шалтгаан оруулна уу");
    } else if (status === 0) {
      context?.request({
        url: `/order/admin/create/${record?.id}`,
        method: "POST",
        ismessage: true,
        model: "reload",
      });
    }
  };

  const handleChangeReason = (e) => setReason(e?.target?.value);

  const sendSeen = () => {
    context
      ?.request({
        url: `/feedback/seen/${record.id}`,
      })
      ?.then((res) => {
        if (res?.success) record.isseen = 1;
      });
  };
  switch (format) {
    case "date":
      return value ? dayjs(value).format("YYYY-MM-DD") : "-";
    case "datetime":
      return value && dayjs(value).format("YYYY-MM-DD HH:mm:ss");
    case "datetimenosec":
      return value && dayjs(value).format("YYYY-MM-DD HH:mm");
    case "actions": {
      if (value === 1) return "Асаах";
      else if (value === 2) return "Унтраах";
      else if (value === 3) return "Цоожлох";
      else if (value === 4) return "Цоож гаргах";
      else if (value === 5) return "Мэдээлэл";
      else if (value === 8) return "Тормоз гишгэх";
      else if (value === 11) return "Хүчдэл багасах";
      else if (value === 9) return "Унтраах үйлдэлүүд цуцлагдах";
      else if (value === 10) return "Түлхүүр 3 дарсан";
      return value;
    }
    case "paymentstatus": {
      if (value === 0)
        return (
          <Tag className="w-20" color="red">
            Амжилтгүй
          </Tag>
        );
      if (value === 1)
        return (
          <Tag className="w-20" color="green">
            Амжилттай
          </Tag>
        );
      if (value === 2)
        return (
          <Tag className="w-20" color="orange">
            Архив
          </Tag>
        );
    }
    case "carinfo": {
      return (
        <div>
          <Button
            className="text-blue cursor-pointer"
            type="link"
            onClick={() => openModal("infoOpen")}
          >
            {value}
          </Button>
          <Modal
            title="Машины мэдээлэл"
            open={isOpen?.infoOpen}
            onClose={() => onClose("infoOpen")}
            isShowFooter={false}
            loading={loading}
            width="20%"
          >
            <div className="text-xs flex flex-col gap-2">
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Машины дугаар</span>
                <span className="font-bold">{record?.carnumber}</span>
              </div>
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Арлын дугааp</span>
                <span className="font-bold">{record?.carcabinnumber}</span>
              </div>
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Үйлдвэрлэсэн он</span>
                <span className="font-bold">{record?.carbuildyear}</span>
              </div>
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Үйлдвэрлэсэн улс</span>
                <span className="font-bold">{record?.carcountry}</span>
              </div>
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Үйлдвэрлэгч</span>
                <span className="font-bold">{record?.carbrand}</span>
              </div>
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Загвар</span>
                <span className="font-bold">{record?.carmodel}</span>
              </div>
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Шатахууны төрөл</span>
                <span className="font-bold">{record?.carfuel}</span>
              </div>
              <div className="flex justify-between p-1 bg-light_card rounded-md">
                <span>Жолооны хүрд</span>
                <span className="font-bold">{record?.carwheel}</span>
              </div>
            </div>
          </Modal>
        </div>
      );
    }
    case "edit":
      return (
        <div>
          <Button
            className="text-blue cursor-pointer"
            type="dashed"
            onClick={() => {
              handleEdit(record);
              /*  localStorage.setItem("editRow", JSON.stringify(row)); */
            }}
          >
            Засах
          </Button>
          <Modal
            title={context?.translate("main.edit")}
            open={isOpenEdit}
            onClose={() => setIsOpenEdit(false)}
            isShowFooter={false}
            loading={loading}
            width="20%"
          >
            <Form
              btnText="Хадгалах"
              handleSave={(e) => saveEdit(e, record)}
              form={editForm}
              initialValues={{
                userid: record?.userid,
                statementid: record?.statementid,
              }}
              loading={loading}
              data={PAYMENT_EDIT_FORM}
              {...context}
            />
          </Modal>
        </div>
      );
    case "status":
      return value === IsEnable.Идэвхтэй ? "Идэвхтэй" : "Идэвхгүй";
    case "iskey":
      return value ? (value === IsEnable.Идэвхтэй ? "Түлхүүр" : "Кноп") : "";
    case "price":
      if (value)
        return new Intl.NumberFormat().format(Math.round(value * 100) / 100);
      return 0;
    case "server":
      if (value === null || value === 0) {
        return <Tag color="red">Хуучин</Tag>;
      } else if (value === 1) {
        return <Tag color="green">Шинэ</Tag>;
      }
      return null;
    case "carisactive":
      if (value === null || value === 0) {
        return <Tag color="red">Унтарсан</Tag>;
      } else if (value === 1) {
        return <Tag color="green">Ассан</Tag>;
      }
      return null;
    case "isactive":
      if (value === null || value === 0) {
        return <Tag color="red">Амжилтгүй</Tag>;
      } else if (value === 1) {
        return <Tag color="green">Амжилттай</Tag>;
      }
      return null;
    case "cartype":
      if (value === null) {
        return null;
      } else if (value === CarType.Sedan) {
        return <span>Sedan</span>;
      } else if (value === CarType.Cuv) {
        return <span>Cuv</span>;
      } else if (value === CarType.Suv) {
        return <span>Suv</span>;
      } else if (value === CarType.Hatchback) {
        return <span>Hatchback</span>;
      } else if (value === CarType.Van) {
        return <span>Van</span>;
      }
      return null;
    case "feedtype":
      if (value === null) {
        return null;
      } else if (value === 1) {
        return <span>Санал хүсэлт</span>;
      } else if (value === 2) {
        return <span>Урам</span>;
      } else if (value === 3) {
        return <span>Асуулт</span>;
      } else if (value === 4) {
        return <span>Шүүмж</span>;
      } else if (value === 5) {
        return <span>Програмын алдаа</span>;
      }
      return null;
    case "verify": {
      return (
        <Popconfirm
          title={() => {
            return (
              <div className="flex flex-col">
                <span>Төлөв солихдоо итгэлтэй байна уу ?</span>
                <div className="flex flex-col mt-2">
                  <span className="text-xs">Төлөв</span>
                  <Select
                    value={status}
                    onChange={(e) => setStatus(e)}
                    options={[
                      { value: 1, label: "Баталсан" },
                      { value: 2, label: "Цуцалсан" },
                      { value: 0, label: "Үүссэн" },
                    ]}
                  />
                </div>
                {status === 2 ? (
                  <Input.TextArea
                    placeholder="Шалтгаан"
                    value={reason}
                    className="mt-2"
                    onChange={handleChangeReason}
                  />
                ) : null}
              </div>
            );
          }}
          placement="topLeft"
          onConfirm={handleVerify}
          okText="Тийм"
          cancelText="Үгүй"
        >
          <span className="text-red-600 cursor-pointer">Төлөв солих</span>
        </Popconfirm>
      );
    }
    case "seen":
      if (value === null) {
        return null;
      } else if (value === 1) {
        return <Tag color="green">Харсан</Tag>;
      } else if (value === 0) {
        return <Tag color="red">Хараагүй</Tag>;
      }
      return null;
    case "orderstatus": {
      if (value === 1) {
        return <Tag color="green">Баталсан</Tag>;
      } else if (value === 2) {
        return <Tag color="red">Цуцалсан</Tag>;
      } else {
        return <Tag color="blue">Үүссэн</Tag>;
      }
    }
    case "ispayd": {
      if (value === IsEnable.Идэвхтэй) {
        return <Tag color="green">Төлсөн</Tag>;
      } else {
        return <Tag color="red">Төлөөгүй</Tag>;
      }
    }
    case "operator":
      if (value === null) {
        return null;
      } else if (value === 1) {
        return <Tag color="red">Мобиком</Tag>;
      } else if (value === 2) {
        return <Tag color="green">Юнител</Tag>;
      } else if (value === 3) {
        return <Tag color="yellow">Жи-мобайл</Tag>;
      }
      return null;
    case "usertype":
      if (value === null) {
        return null;
      } else if (value === UserType.Супер_админ) {
        return <span>Супер админ</span>;
      } else if (value === UserType.Админ) {
        return <span>Админ</span>;
      } else if (value === UserType.Хэрэглэгч) {
        return <span>Хэрэглэгч</span>;
      } else if (value === UserType.Салбар_Админ) {
        return <span>Салбар админ</span>;
      }
      return null;
    case "see":
      return (
        <div>
          <Button
            type="dashed"
            onClick={() => {
              sendSeen();
              openModal("carOpen");
            }}
          >
            Харах
          </Button>
          <Modal
            title={context?.translate("sider.feedback")}
            open={isOpen?.carOpen}
            onClose={() => onClose("carOpen")}
            isShowFooter={false}
            loading={loading}
          >
            <span className="text-center">"{record.text}"</span>
          </Modal>
        </div>
      );
    case "img":
      if (value) {
        return (
          <div className="flex items-center justify-center">
            <Tooltip title={<img src={`${URLS.image}/${value}`} />}>
              <img
                className="table-img h-10 w-10 rounded-md"
                src={`${URLS.image}/${value}`}
                alt="img"
                onError={({ currentTarget }) => {
                  currentTarget.src = noimage;
                }}
              />
            </Tooltip>
          </div>
        );
      } else {
        return <span>Зураггүй</span>;
      }
    case "delete":
      return (
        <Popconfirm
          title={() => {
            return (
              <div className="flex flex-col">
                <span>Устахдаа итгэлтэй байна уу?</span>
              </div>
            );
          }}
          placement="topLeft"
          onConfirm={handleDelete}
          okText="Тийм"
          cancelText="Үгүй"
        >
          <span className="text-red-600 cursor-pointer">Устгах</span>
        </Popconfirm>
      );
    case "formmodal":
      return (
        <div>
          <Button type="dashed" onClick={() => openModal("carOpen")}>
            {context?.translate("main.register")}
          </Button>
          <Modal
            title={context?.translate(formData?.title)}
            open={isOpen?.carOpen}
            onClose={() => onClose("carOpen")}
            isShowFooter={false}
            loading={loading}
            width="20%"
          >
            <Form
              btnText="Хадгалах"
              handleSave={(e) => saveCars(e, record)}
              initialValues={formData?.initialValues}
              loading={loading}
              data={formData?.data}
              {...context}
            />
          </Modal>
        </div>
      );
    default:
      return value;
  }
};

export default Index;
